import { UUID } from "../generic/uuid";
import {
  createSupplierDtoFromOfferSupplierModel,
  SupplierModel,
} from "./supplier";
import { createSellerDtoFromOfferSellerModel, SellerModel } from "./seller";
import {
  createVintageProductDtoFromOfferVintageProductModel,
  VintageProductModel,
} from "./vintageProduct";
import { createPriceDtoFromOfferPriceModel, PriceModel } from "./price";
import { PackageEnum } from "@vini-wine/core-enums";
import { CountryModel, createCountryDtoFromOfferCountryModel } from "./country";
import { OfferDto, VintageProductDto } from "@vini-wine/core-dtos";

export interface OfferModel extends UUID {
  // default includes
  price: PriceModel | null;

  // transform
  quantity: number;
  package: PackageEnum | null;
  createdAt: Date;

  // available includes
  supplier?: SupplierModel | null;
  seller?: SellerModel;
  vintageProducts?: VintageProductModel[];
  shippedFromCountry?: CountryModel | null;
}

export const createOfferDtoFromOfferOfferModel = (
  offer: OfferModel,
): OfferDto => {
  const vintageProducts: VintageProductDto[] = [];
  if (offer.vintageProducts && offer.vintageProducts.length) {
    for (let i = 0; i < offer.vintageProducts.length; i += 1) {
      vintageProducts.push(
        createVintageProductDtoFromOfferVintageProductModel(
          offer.vintageProducts[i],
        ),
      );
    }
  }
  return {
    uuid: offer.uuid,
    createdAt: offer.createdAt,
    package: offer.package,
    price: offer.price ? createPriceDtoFromOfferPriceModel(offer.price) : null,
    quantity: offer.quantity,
    seller: offer.seller
      ? createSellerDtoFromOfferSellerModel(offer.seller)
      : undefined,
    supplier: offer.supplier
      ? createSupplierDtoFromOfferSupplierModel(offer.supplier)
      : undefined,
    shippedFromCountry: offer.shippedFromCountry
      ? createCountryDtoFromOfferCountryModel(offer.shippedFromCountry)
      : undefined,
    vintageProducts,
  };
};
